import { DealContractType } from 'modules/domain/deal/types'
import { ProductPurpose } from 'modules/domain/documentRequest/types'
import { Elevator, ElevatorCosts } from 'modules/domain/warehouses/types'
import { RailwayStation } from 'views/pages/LogisticsKR/Rates/types'

export enum RatingTypes {
  contract_signing_speed = 'contract_signing_speed',
  documents_collecting = 'documents_collecting',
  overpayment_refund = 'overpayment_refund',
  seller_quality = 'seller_quality',
  shipment_speed = 'shipment_speed',
}

export enum CloningTypes {
  seller_change = 'seller_change',
  customer_change = 'customer_change',
  quantity_split = 'quantity_split',
}

export interface CloningFormFields {
  new_bid: string
  quantity: number | string
  price_exw: number | string
  price_cpt: number | string
  distance: number | string
  logistics_rate: number | string
  price_logistics: number | string
  price_logistics_with_overload: number | string
  railway_price_logistics: number | string | null
  logistics_rate_with_overload: number | string
  cloning_type: CloningTypes
  user: string
}

export type DealProductDTO = {
  id?: number
  parameter?: number
  parameter_value?: string
}

export interface DealContractForm {
  deal: string
  contract_type: DealContractType
  dispatching_date: string
  payment_terms: string
  transfer_address: string
  email: string
  phone: string
  conformity_declaration_type: DealContractType
  season: string
  quantity: string | number
  price: number
  has_vat: boolean
  product_purpose: ProductPurpose
  parameters: DealProductDTO[]
  main_param?: DealProductDTO
  parameters_comment: string
}

export enum RegionalWorkType {
  sample = 'sample',
  documents = 'documents',
  loading = 'loading',
}

export type Regionals = {
  regional: string
  work_type: RegionalWorkType
}

export type ExecutorsForm = {
  user_coordinator?: string | number | null
  deal_coordinator?: string | number | null
  shipment_coordinator?: string | number | null
  logisticians?: (string | number)[]
  regional?: string | number | null
  trader?: string | number | null
  logistician?: string | null
  regionals?: string[] | number[] | null
  regionals_with_type?: Regionals[]
  sample?: string
  documents?: string
  loading?: string
  ignore_quality?: boolean
}

export type DealRailwayData = Omit<ElevatorCosts, 'comment'> & {
  deal: number
  elevator: Omit<Elevator, 'elevator_costs'>
  storage_days: number | null
  farmer_transit_costs: number | null
  from_station: RailwayStation
  to_station: RailwayStation
  rate: number | null
}

export type DealRailwayDataDTO = Omit<ElevatorCosts, 'comment' | 'id'> & {
  elevator: string | null
  farmer_transit_costs: number | null
  storage_days: number | null
  from_station: string | null
  to_station: string | null
  rate: number | null
}
